<template>
  <dev-tools />
</template>

<script>
export default {
  name: 'Develop',
  components: {
    DevTools: () => import('./DevTools.vue'),
  },
}
</script>
